export enum UserRole {
  User = 'user',
  Admin = 'Admin',
}
